import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ProjectCompletion::ProjectCompletion />",{ moduleName: "sh-www/templates/project-completion/public-feedback.hbs" })